import api from 'api/axiosInstance';
import type { SubscriptionPlan } from 'types/subscriptions.types';

const getSubscriptionPlans = (): Promise<SubscriptionPlan[]> =>
  api.get('/v1/subscriptions/stripe/plans');

export default getSubscriptionPlans;
